import React from 'react';

import { ReactComponent as Icon } from 'assets/img/vectors/rating/rating-unsure.svg';

const RatingUnsure = (props) => (
   <Icon { ...props }/>
);

export default RatingUnsure;
